<div class="dashboard">
  @if (authService.hasAccess(Role.PartnerAdmin)) {
    <app-customerlist></app-customerlist>
  }
</div>
